import queryClient from '@/utils/reactQueryClient';
import {CAMPAIGN_V2_INVITED_CREATORS_BASE_QUERY_KEY} from '@/hooks/queries/use-campaign-invited-creators-query';
import {CAMPAIGN_V2_CREATORS_COUNTS_BASE_QUERY_KEY} from '@/hooks/queries/use-campaign-v2-creators-counts-query';
import {OFF_PLATFORM_CREATOR_QUERY_KEY} from '@/hooks/queries/use-off-platform-creator-query/useOffPlatformCreatorQuery';

export const BULK_INVITE_REQUERY_DELAYS_MS = [3_000, 10_000] as const;

export default function invalidateCampaignInvitedQueries() {
  queryClient.invalidateQueries({
    queryKey: [CAMPAIGN_V2_INVITED_CREATORS_BASE_QUERY_KEY],
    exact: false,
  });
  queryClient.invalidateQueries({
    queryKey: [CAMPAIGN_V2_CREATORS_COUNTS_BASE_QUERY_KEY],
    exact: false,
  });
  queryClient.invalidateQueries({
    queryKey: [OFF_PLATFORM_CREATOR_QUERY_KEY],
    exact: false,
  });
}

export function invalidateCampaignInvitedQueriesAfterEnqueue(
  retryDelaysMs: readonly number[] = BULK_INVITE_REQUERY_DELAYS_MS
) {
  invalidateCampaignInvitedQueries();
  retryDelaysMs.forEach((delayMs) => {
    window.setTimeout(invalidateCampaignInvitedQueries, delayMs);
  });
}
